import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/addModalSlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { createAd, getAllAds } from "../../store/slices/apiAdsSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const AddAdsModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.addModal.isOpen);
  const categoryOptions = useSelector((state) => state.apiCategory.data);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [schoolIsActive, setSchoolIsActive] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description || !image) {
      toast.error("Ju lutem plotësoni të gjitha fushat!");
      return;
    }

    const selectedCategoryId = selectedOption ? selectedOption.value : null;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("category_id", selectedCategoryId);
    formData.append("status", schoolIsActive ? 1 : 0);
    formData.append("image", image);

    try {
      await dispatch(createAd(formData)).unwrap();
      dispatch(getAllAds());
      setTitle("");
      setDescription("");
      setImage(null);
      setSelectedOption(null);
      setSchoolIsActive(false);
      handleCloseModal();
      toast.success("Reklama u shtua me sukses!");
    } catch (error) {
      console.error("Gabim gjatë shtimit të reklamës:", error);
      toast.error("Gabim gjatë shtimit të reklamës.");
    }
  };

  const handleOpenModal = () => {
    dispatch(openModal());
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleSchoolStatusChange = (isChecked) => {
    setSchoolIsActive(isChecked);
  };

  return (
    <div>
      <button
        onClick={handleOpenModal}
        className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-3 py-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
      >
        Shto Reklamë
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-15">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>
          <div
            className="relative bg-white rounded-lg shadow-lg"
            style={{ width: "360px" }}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500">
                Shto Reklamë
              </h3>
              <form
                className="space-y-6 text-start"
                onSubmit={handleSubmit}
                encType="multipart/form-data"
              >
                <div>
                  <label
                    htmlFor="title"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Titulli:
                  </label>
                  <input
                    type="text"
                    name="title"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  />
                </div>

                <div>
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Përshkrimi:
                  </label>
                  <textarea
                    name="description"
                    id="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  ></textarea>
                </div>

                <div>
                  <label
                    htmlFor="input2"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Zgjedh kategorinë:
                  </label>
                  <Select
                    isClearable
                    id="input2"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    options={categoryOptions.map((option) => ({
                      value: option.id,
                      label: option.name,
                    }))}
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Statusi:
                  </label>
                  <div className="flex flex-wrap gap-2">
                    <button
                      type="button"
                      className={`text-sm rounded-lg px-4 py-2 ${
                        schoolIsActive
                          ? "bg-green-500 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => handleSchoolStatusChange(true)}
                    >
                      Aktiv
                    </button>
                    <button
                      type="button"
                      className={`text-sm rounded-lg px-4 py-2 ${
                        !schoolIsActive
                          ? "bg-red-500 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                      onClick={() => handleSchoolStatusChange(false)}
                    >
                      Pasiv
                    </button>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="image"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Imazhi:
                  </label>
                  <input
                    type="file"
                    name="image"
                    id="image"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  />
                </div>

                <div className="flex justify-center">
                  <button
                    type="submit"
                    className="text-white bg-blue-500 hover:bg-blue-600 rounded-lg border text-sm font-medium px-5 py-2.5 mr-2"
                  >
                    Shto
                  </button>
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 rounded-lg border text-sm font-medium px-5 py-2.5"
                  >
                    Anulo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default AddAdsModal;
